'use client'
import React, { useEffect } from 'react'
import { isMobileDevice } from 'helpers/utilities'

import OnlineResumeMobile from './index.mobile'
import OnlineResumePc from './index.pc'
import { useAttachedResumeContext, withAttachedResumeProvider } from '../AttachedResume/context'
import { useMainResumeContext } from '../Main/context'

const OnlineResumeMain = (props: { lang: string; config: any; step: any }) => {
  const isMobile = isMobileDevice()

  const { userInfo: userDetail, getUserInfo } = useMainResumeContext()
  const { setUserDetail, initData } = useAttachedResumeContext()

  useEffect(() => {
    if (userDetail?.id) {
      setUserDetail(userDetail)
      initData(userDetail)
    }
  }, [userDetail])

  if (isMobile) {
    return <OnlineResumeMobile {...props} />
  }

  return <OnlineResumePc {...props} />
}

export default withAttachedResumeProvider(OnlineResumeMain)
